import React, { FC, ReactNode } from "react";
import { RecurlyProvider, Elements } from "@recurly/react-recurly";
import { captureException } from "@sentry/react";
import { FieldNames, RECURLY_JS_URL } from "../../constants";
import { config } from "../../../../../config";
import { useExternalScript } from "shared-hooks";
import { Spinner } from "../../../../Atoms/Spinner/Spinner";

const RecurlyWrapper: FC<React.PropsWithChildren<{ children: ReactNode }>> = ({
  children,
}) => {
  const [loaded, error] = useExternalScript(RECURLY_JS_URL);

  if (error) {
    captureException(error);
  }

  if (!loaded) {
    return <Spinner />;
  }

  return (
    <RecurlyProvider
      publicKey={config.recurlyToken}
      required={[FieldNames.cvv, FieldNames.postalCode]}
    >
      <Elements>{children}</Elements>
    </RecurlyProvider>
  );
};

export default RecurlyWrapper;
